import { render, staticRenderFns } from "./AdminAddPromotion2023.vue?vue&type=template&id=787e9561&scoped=true"
import script from "./AdminAddPromotion2023.vue?vue&type=script&lang=js"
export * from "./AdminAddPromotion2023.vue?vue&type=script&lang=js"
import style0 from "./AdminAddPromotion2023.vue?vue&type=style&index=0&id=787e9561&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787e9561",
  null
  
)

export default component.exports